import MarketingWordPressApi from "@/services/MarketingWordPressApi";

export default {
  getEvents() {
    return MarketingWordPressApi.get(
      "wp-json/wp/v2/event?acf_format=standard&_embed&per_page=30",
    );
  },
};
